import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import store, { persistor } from "./redux/store";
import App from "./App";
import LoadingSpinner from "./components/LoadingSpinner";

// Import contexts
import { NotificationProvider } from "./context/NotificationContext";
import { AuthProvider } from "./context/AuthContext";
import { NotificacionesProvider } from "./context/NotificacionesContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate
      loading={<LoadingSpinner message="Inicializando aplicación..." />}
      persistor={persistor}
    >
      <AuthProvider>
        <NotificationProvider>
          <NotificacionesProvider>
            <BrowserRouter>
              <App />
              <ToastContainer
              
              tContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999 }}
              />
            </BrowserRouter>
          </NotificacionesProvider>
        </NotificationProvider>
      </AuthProvider>
    </PersistGate>
  </Provider>
);
